import { render, staticRenderFns } from "./AdmisionInscritosModalidadBEsfm.vue?vue&type=template&id=3df4b03d"
import script from "./AdmisionInscritosModalidadBEsfm.vue?vue&type=script&lang=js"
export * from "./AdmisionInscritosModalidadBEsfm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports